import { z } from "zod";

export type Contact = z.infer<typeof ContactSchema>;
export const ContactSchema = z.object({
  name: z.string().optional(),
  email: z.string().email("Invalid email address.").optional(),
  phone: z.string().optional()
});